export const STORAGE_KEY = 'loto_app_v4';
export const LOCALE_STORAGE_KEY = 'loto_ui_locale';
export const ANIMATIONS_STORAGE_KEY = 'disable-animations';
